import { Layout, Button, Divider, theme as antdTheme } from 'antd';
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  MenuOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import { useUiStore } from '@/store/ui';
import { ThemePicker } from '@/app/theme-picker';
import { YearPicker } from '@/app/year-picker';
import { UserMenu } from '@/app/user-menu';
import { AppBreadcrumbs } from '@/app/breadcrumbs';
import { NotificationCenter } from '@/app/notification-center';
import { useCommandPaletteStore } from '@/store/command-palette';
import { useIsMobile } from '@/shared/hooks/use-media';

export function AppHeader() {
  const collapsed = useUiStore((s) => s.siderCollapsed);
  const toggleSider = useUiStore((s) => s.toggleSider);
  const openMobileMenu = useUiStore((s) => s.openMobileMenu);
  const openPalette = useCommandPaletteStore((s) => s.open);
  const { token } = antdTheme.useToken();
  const isMobile = useIsMobile();

  return (
    <Layout.Header
      className="app-header"
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 10,
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        borderBottom: `1px solid ${token.colorBorderSecondary}`,
        backdropFilter: 'saturate(140%) blur(8px)',
      }}
    >
      <Button
        type="text"
        size="large"
        aria-label={isMobile ? 'Open menu' : 'Toggle sider'}
        icon={isMobile ? <MenuOutlined /> : collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        onClick={isMobile ? openMobileMenu : toggleSider}
      />

      {!isMobile && (
        <div style={{ minWidth: 0, flexShrink: 0 }}>
          <AppBreadcrumbs />
        </div>
      )}

      <div style={{ flex: 1, display: 'flex', justifyContent: isMobile ? 'flex-end' : 'center' }}>
        {isMobile ? (
          <Button
            type="text"
            size="large"
            aria-label="Search"
            icon={<SearchOutlined />}
            onClick={openPalette}
          />
        ) : (
          <button
            type="button"
            className="search-trigger"
            aria-label="Open command palette"
            onClick={openPalette}
          >
            <SearchOutlined />
            <span>Search students, fees, staff…</span>
            <kbd>⌘K</kbd>
          </button>
        )}
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
        {!isMobile && <YearPicker />}
        {!isMobile && <ThemePicker />}
        <NotificationCenter />
        {!isMobile && <Divider orientation="vertical" style={{ height: 24, margin: '0 4px' }} />}
        <UserMenu />
      </div>
    </Layout.Header>
  );
}
